// assets
import { DashboardOutlined, IdcardOutlined, FileTextOutlined, MailOutlined } from '@ant-design/icons';

// icons
const icons = {
  DashboardOutlined,
  IdcardOutlined,
  FileTextOutlined,
  MailOutlined
};

// ==============================|| MENU ITEMS - Kairos Management ||============================== //

// Determine whether to show developer-only items at runtime based on stored user role
const kairos = {
  id: 'kairos',
  title: 'Kairos Management',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard',
      icon: icons.DashboardOutlined
    },
    {
      id: 'kairos-card',
      title: 'Kairos Card',
      type: 'item',
      url: '/kairos-card',
      icon: icons.IdcardOutlined,
      requiresDeveloperOrSuperAdmin: true
    },
    {
      id: 'ugc-submissions',
      title: 'UGC Submissions',
      type: 'item',
      url: '/ugc-submissions',
      icon: icons.FileTextOutlined
    },
    {
      id: 'newsletter-subscribers',
      title: 'Newsletter Subscribers',
      type: 'item',
      url: '/newsletter-subscribers',
      icon: icons.MailOutlined
    }
  ]
};

export default kairos;
